import api, { handleApiError } from './api';
import { saveToken, saveUserData, clearAll } from '../utils/storage';

// Registrierung
export const register = async (email, password, firstName, lastName, familyName, invitationCode) => {
  try {
    const response = await api.post('/auth/register', {
      email,
      password,
      firstName,
      lastName,
      familyName,
      invitationCode,
    });
    
    const { token, user } = response.data;
    
    // Token und User-Daten speichern
    await saveToken(token);
    await saveUserData(user);
    
    return { success: true, user, token };
  } catch (error) {
    return { success: false, error: handleApiError(error) };
  }
};

// Login
export const login = async (email, password) => {
  try {
    const response = await api.post('/auth/login', {
      email,
      password,
    });
    
    const { token, user } = response.data;
    
    // Token und User-Daten speichern
    await saveToken(token);
    await saveUserData(user);
    
    return { success: true, user, token };
  } catch (error) {
    return { success: false, error: handleApiError(error) };
  }
};

// Logout
export const logout = async () => {
  try {
    await clearAll();
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// Aktuellen User abrufen
export const getCurrentUser = async () => {
  try {
    const response = await api.get('/auth/me');
    return { success: true, user: response.data };
  } catch (error) {
    return { success: false, error: handleApiError(error) };
  }
};

// User-Präferenzen aktualisieren
export const updatePreferences = async (preferences) => {
  try {
    const response = await api.put('/auth/preferences', preferences);
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, error: handleApiError(error) };
  }
};

